
import React from 'react';
import { Button } from '@/components/ui/button';
import { Plus, Save, X } from 'lucide-react';

interface HotelFormActionsProps {
  onSave: () => void;
  onCancel?: () => void;
  isValid: boolean;
  isEditMode?: boolean;
}

export const HotelFormActions: React.FC<HotelFormActionsProps> = ({ 
  onSave, 
  onCancel, 
  isValid, 
  isEditMode = false 
}) => {
  return (
    <div className="flex gap-2">
      <Button 
        onClick={onSave}
        className={`flex-1 text-white font-medium ${isEditMode 
          ? 'bg-purple-tertiary hover:bg-purple-dark border border-purple-tertiary/20' 
          : 'bg-bright-purple hover:bg-purple-tertiary shadow-md border border-purple-light/20'}`}
        disabled={!isValid}
      >
        {isEditMode ? (
          <>
            <Save className="mr-2 h-4 w-4" />
            Update Hotel Details
          </>
        ) : (
          <>
            <Plus className="mr-2 h-4 w-4" />
            Save Hotel Details
          </>
        )}
      </Button>
      
      {isEditMode && onCancel && (
        <Button 
          onClick={onCancel}
          variant="outline"
          className="flex-1 border-purple-light hover:bg-purple-soft/30 text-purple-tertiary"
        >
          <X className="mr-2 h-4 w-4" />
          Cancel
        </Button>
      )}
    </div>
  );
};
